



















import { Component, Mixins, Prop, Watch, Emit } from 'vue-property-decorator';
import { hasElements } from '../utils';
import Axios from 'axios';
import { NotificationStoreHelper, RootStoreHelper } from '../mixins';
import { Destroyed, Mounted } from '../decorators';

@Component({
    components: {}
})
export default class PictureModal extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    @Prop({ default: '' }) imageUrl: string;
    @Prop({ default: '600' }) maxWidth: string;
    @Prop({ default: false }) hideOverlay: boolean;
    @Prop({ default: false }) visible: boolean;

    @Emit()
    closeModal() {}

    clickOutside() {}
}
